module.exports = __webpack_public_path__ + "img/appAsset--compliance--flow-destination--1-2--active--blue.04e7bd2f.svg";